import React, { useEffect } from 'react'
import { useTable, usePagination, useSortBy } from 'react-table'

import TableHeader from '../shared/TableHeader'
import TableFooter from './TableFooter'
import TableBody from '../shared/TableBody'
import { convertFromParams } from '../../../../utils/table/sortBy'
import getAppliedFilterString from '../../../../utils/table/getAppliedFilterString'
import Spinner from '../../Spinner'

const Table = ({
    name,
    columns,
    data,
    loading,
    pageCount: controlledPageCount,
    resultsCount,
    filterExpanded,
    filterFields,
    onClick,
    setParams,
    params,
    selectedItems,
    selectedItemColumn,
    promotedRecords,
    showAppliedFilterString = true,
    extraClass = null,
    manualPagination = true
}) => {
    const initialPageIndex = manualPagination && (params && params[name]) ? Number(params[name].Page) - 1 : 0
    const initialPageSize = (params && params[name]) ? Number(params[name].PageSize) : 50
    const initialSortBy = (params && params[name]) ? convertFromParams(params[name].SortByField, params[name].SortOrder) : []
    const initialPage = manualPagination && (params && params[name]) ? params[name].Page : null
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        preSortedRows,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize, sortBy },
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: initialPageIndex,
                pageSize: initialPageSize,
                sortBy: initialSortBy,
                hiddenColumns: ['FacilityID']
            }, // Pass our hoisted table state
            manualPagination: manualPagination, // pagination
            manualSorting: true,
            autoResetSortBy: false,
            disableSortRemove: true,
            pageCount: manualPagination ? controlledPageCount : undefined,
        },
        useSortBy,
        usePagination
    )

    // page info fetch
    useEffect(() => {
        if (manualPagination) {
            const sortByProps = sortBy.length
                ? {
                      SortByField: `${sortBy[0].id}`,
                      SortOrder: sortBy[0].desc ? 'DESC' : 'ASC',
                  }
                : {}
            let newParams = {
                ...params[name],
                ...sortByProps,
                PageSize: pageSize
            }
            if (manualPagination) {
                newParams = {
                    ...newParams, 
                    Page: ( pageIndex + 1 ), 
                }
            }
            setParams(newParams, name)
        }
    }, [pageIndex, pageSize, sortBy])

    useEffect(() => {
        if (initialPage) {
            gotoPage(initialPage - 1)
        } 
    }, [initialPage])

    // Render the UI for your table
    return (
        <>
            <div
                className={`container table-container ${
                    filterExpanded ? 'is-hidden' : 'is-visible'
                } explorerTableWrapper ${extraClass ? extraClass : ''}`}
            >
                <div className="filterSummaryWrapper">
                    <div className="filterSummaryText">
                        {showAppliedFilterString && getAppliedFilterString(params[name], filterFields)}
                    </div>
                </div>
                <table
                    {...getTableProps()}
                    className="table is-striped is-fullwidth is-hoverable explorerTable"
                >
                    {loading ? (
                        <tbody>
                            <tr>
                                <td colSpan="100%">
                                    <Spinner />
                                </td>
                            </tr>
                        </tbody>
                    ) : (<>
                        <TableHeader headerGroups={headerGroups} />
                        <TableBody
                            {...{
                                getTableBodyProps,
                                page: promotedRecords ? preSortedRows : page,
                                prepareRow,
                                loading,
                                controlledPageCount,
                                selectedItems,
                                selectedItemColumn,
                                pageSize,
                                onClick
                            }}
                        />
                    </>)}
                </table>
            </div>
            <TableFooter
                {...{
                    filterExpanded,
                    gotoPage,
                    previousPage,
                    canPreviousPage,
                    nextPage,
                    canNextPage,
                    pageCount,
                    resultsCount,
                    pageOptions,
                    pageIndex,
                    pageSize,
                    setPageSize,
                    loading,
                }}
            />
        </>
    )
}

export default Table
